import * as DataModel from '../model/FrequencyAnalysisModel'

export class FrequencyAnalysisController {
    model = null;

    constructor() {
        this.setupCipher();
    }

    setupCipher() {
        this.model = new DataModel.FrequencyAnalysisModel();

        this.model.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        this.model.scrambledAlphabet = [];
        this.model.totalLetters = 0;
        this.model.letterCounts = [];
        this.model.letterFrequencies = [];
        this.model.descrambleAttempt = [];
        for (let i = 0; i < 26; i++) {
            this.model.scrambledAlphabet.push(this.model.alphabet[i]);
            this.model.letterCounts.push(0);
            this.model.letterFrequencies.push(0);
            this.model.descrambleAttempt.push('');
        }
        this.model.scrambledAlphabet.sort(() => Math.random() - 0.5);
        this.model.cipherPhrase = DataModel.FEQUENCY_PHRASES[Math.floor(Math.random() * DataModel.FEQUENCY_PHRASES.length)].toUpperCase();
        let phraseSplit = this.model.cipherPhrase.split('');
        let scrambledArray = [];
        let lineBreakCharCount = 0
        // let blueIt = true;
        for (let i = 0; i < phraseSplit.length; i++) {
            lineBreakCharCount++;
            if (this.model.alphabet.indexOf(phraseSplit[i]) >= 0) {
                let l = this.model.scrambledAlphabet[this.model.alphabet.indexOf(phraseSplit[i])];
                scrambledArray.push(l);
                this.model.totalLetters++;
                this.model.letterCounts[this.model.alphabet.indexOf(l)]++;
                if (lineBreakCharCount >= DataModel.LINE_BREAK_EVERY + 4 && i < phraseSplit.length - 1 && this.model.alphabet.indexOf(phraseSplit[i + 1]) >= 0 && this.model.alphabet.indexOf(phraseSplit[i + 2]) >= 0) {
                    scrambledArray.push('-|');
                    lineBreakCharCount = 0;
                }
            } else {
                // some punctuation or something else that isn't scrambled
                if (phraseSplit[i] === '|' || (lineBreakCharCount >= DataModel.LINE_BREAK_EVERY && phraseSplit[i] === ' ')) {
                    scrambledArray.push('|');
                    /*
                    if (blueIt) {
                        scrambledArray.push('<blue>');
                    } else {
                        scrambledArray.push('</blue>');
                    }
                    blueIt = !blueIt;
                    */
                    lineBreakCharCount = 0;
                } else {
                    scrambledArray.push(phraseSplit[i]);
                }
            }
        }
        this.model.scrambledPhrase = scrambledArray.join('');
        for (let i = 0; i < 26; i++) {
            if (this.model.letterCounts[i] > 0) {
                let f = this.model.letterCounts[i] / this.model.totalLetters * 100;
                this.model.letterFrequencies[i] = f;
            }
        }

        // console.log('Phrase: ' + this.model.cipherPhrase);
        // console.log('Scrambled: ' + this.model.scrambledPhrase);
        // console.log(this.model);

        this.model.currentTestShift = 0;
    }

    enterDescrambleAttemptLetter(index, char) {
        if (char === '' || char === 'Delete' || char === 'Backspace' || char === ' ' || this.model.descrambleAttempt[index] === char.toUpperCase()) {
            this.model.descrambleAttempt[index] = '';
        } else {
            char = char.toUpperCase();
            if (this.model.alphabet.indexOf(char) >= 0) {
                if (this.model.descrambleAttempt.indexOf(char) >= 0) {
                    this.model.descrambleAttempt[this.model.descrambleAttempt.indexOf(char)] = '';
                }
                this.model.descrambleAttempt[index] = char;
            }
        }
        // console.log('descramble attempt: ', this.model.descrambleAttempt);
    }

    clearAllLetters() {
        for (let i = 0; i < this.model.descrambleAttempt.length; i++) {
            this.model.descrambleAttempt[i] = '';
        }
    }

    checkAnswer() {
        // console.log('checking freq answer');
        for (let i = 0; i < this.model.descrambleAttempt.length; i++) {
            if (this.model.letterCounts[i] > 0/* && this.model.descrambleAttempt[i] !== this.model.scrambledAlphabet[i]*/) {
                // so to check our solution, we find the index of the letter at index i of our scrambled array in the normal alphabet
                // and our descramble attempt at that index should be the correct letter for index i in our normal alphabet
                // which seems to make no sense, but it is correct!
                // console.log('index: ' + i, 'count: ' + this.model.letterCounts[i], this.model.alphabet[i], this.model.scrambledAlphabet[i], this.model.descrambleAttempt[i]);
                let scrambledLetterNormalIndex = this.model.alphabet.indexOf(this.model.scrambledAlphabet[i])
                // console.log('scrambled letter is index ' + scrambledLetterNormalIndex + ' in alphabet');
                // console.log(this.model.descrambleAttempt[scrambledLetterNormalIndex] + ' should match ' + this.model.alphabet[i]);
                let descrambledLetter = this.model.descrambleAttempt[scrambledLetterNormalIndex];
                if (descrambledLetter !== '' && this.model.alphabet.indexOf(descrambledLetter) !== i) {
                    return false;
                }
            }
        }
        return true;
    }
}